import { useCallback, useRef, useState } from "react"
import { usePlanning } from "../components/PlanningContext"

// "blocked" (an absence) still fires the drop so that the person is told why.
const useDropTarget = ({ accepts, blocked, onDrop }) => {
  const { dragRef } = usePlanning()
  const [over, setOver] = useState(null)
  const depth = useRef(0)

  const canTake = () => dragRef.current && accepts.includes(dragRef.current.type)

  const onDragEnter = useCallback(event => {
    if (!canTake()) return
    event.preventDefault()
    depth.current += 1
    setOver(blocked ? "blocked" : "ok")
  }, [blocked, accepts])

  const onDragOver = useCallback(event => {
    if (!canTake()) return
    event.preventDefault()
    const drag = dragRef.current
    event.dataTransfer.dropEffect = drag.type === "assignment" && !event.altKey ? "move" : "copy"
    drag.altKey = event.altKey
  }, [blocked, accepts])

  const onDragLeave = useCallback(() => {
    depth.current = Math.max(0, depth.current - 1)
    if (depth.current === 0) setOver(null)
  }, [])

  const handleDrop = useCallback(event => {
    if (!canTake()) return
    event.preventDefault()
    depth.current = 0
    setOver(null)
    onDrop(dragRef.current, event.altKey || dragRef.current.altKey)
  }, [onDrop, accepts])

  return { over, dropProps: { onDragEnter, onDragOver, onDragLeave, onDrop: handleDrop } }
}

export default useDropTarget
